var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 40,
    viewBox: "0 0 72 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 39,
    rx: 4.5,
    stroke: "#E7E7E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 40,
    rx: 5,
    fill: "#D1F27A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2615 18.2615H35.2385V12.2384C35.2385 11.8303 34.9077 11.5 34.5 11.5C34.0924 11.5 33.7615 11.8303 33.7615 12.2384V18.2615H27.7385C27.3309 18.2615 27 18.5924 27 19C27 19.4082 27.3309 19.7385 27.7385 19.7385H33.7615V25.7615C33.7615 26.1697 34.0924 26.5 34.5 26.5C34.9077 26.5 35.2385 26.1697 35.2385 25.7615V19.7385H41.2615C41.6692 19.7385 42 19.4082 42 19C42 18.5924 41.6692 18.2615 41.2615 18.2615Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRole);
export default __webpack_public_path__ + "static/media/plus_role.e4592ee5ed991a302b600d9b337ff49f.svg";
export { ForwardRef as ReactComponent };